import { render } from "./nest_modal_sidebar.vue?vue&type=template&id=c985f84c"
import script from "./nest_modal_sidebar.vue?vue&type=script&lang=js"
export * from "./nest_modal_sidebar.vue?vue&type=script&lang=js"

import "./nest_modal_sidebar.vue?vue&type=style&index=0&id=c985f84c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__